import * as React from "react";

function ErrorIcon(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 50 50" {...props}>
      <g fill="none" fillRule="evenodd">
        <circle cx={25} cy={25} r={25} fill="#D0021B" fillRule="nonzero" />
        <path
          fill="#FFF"
          d="M36.854 16.52L28.213 25l8.642 8.48a2.122 2.122 0 010 3.007l-.389.369c-.833.822-2.223.822-3.056 0l-8.42-8.254-8.42 8.281c-.833.823-2.223.823-3.056 0l-.389-.368a2.122 2.122 0 010-3.007L21.765 25l-8.64-8.48a2.122 2.122 0 010-3.007l.389-.369c.833-.822 2.223-.822 3.056 0l8.42 8.254 8.419-8.281c.833-.823 2.223-.823 3.056 0l.389.368c.861.85.861 2.184 0 3.035z"
        />
      </g>
    </svg>
  );
}

const MemoErrorIcon = React.memo(ErrorIcon);
export default MemoErrorIcon;
